import { UntilDestroy } from '@ngneat/until-destroy'
import { Component, input, model, output } from '@angular/core'
import { TbCheckboxComponent } from '@components-library/tb-checkbox/checkbox.component'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'
import { MatIconModule } from '@angular/material/icon'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'

@UntilDestroy()
@Component({
    selector: 'app-field-configuration-type',
    templateUrl: './field-configuration-type.component.html',
    imports: [MatIconModule, TbButtonComponent, TbCheckboxComponent, TbIconComponent],
})
export class FieldConfigurationTypeComponent {
    icon = input.required<string>()
    name = input.required<string>()
    description = input.required<string>()
    active = model(false)

    settings = output()
}
